export const KenobiCodes = {
    ACCMS: {
        functionality: 'ACCMS',
        rubric: '*',
    },
    CTROPT: {
        functionality: 'CTROPT',
        rubric: 'A',
    },
    FACTMC: {
        functionality: 'FACTMC',
        rubric: 'F',
    },
    HPCOMPTE: {
        functionality: 'HPCOMPTE',
        rubric: 'I',
    },
    MSUPCTR: {
        functionality: 'MSUPCTR',
        rubric: '*',
    },
    LISUPCTR: {
        functionality: 'LISUPCTR',
        rubric: '*',
    },
    PSUPCTR: {
        functionality: 'PSUPCTR',
        rubric: '*',
    },
    SUPCTRBL: {
        functionality: 'SUPCTRBL',
        rubric: '*',
    },
    CNAFFRAP: {
        functionality: 'CNAFFRAP',
        rubric: '*',
    },
    CRATTRAP: {
        functionality: 'CRATTRAP',
        rubric: '*',
    },
    ACCNCONS: {
        functionality: 'ACCNCONS',
        rubric: '*',
    },
    ACCSCONT: {
        functionality: 'ACCSCONT',
        rubric: '*',
    },
    HPVISITOR: {
        functionality: 'ESPCLINL',
        rubric: '*',
    },
    IDENTCR: {
        functionality: 'IDENTCR',
        rubric: 'F',
    },
    CAPTCHCR: {
        functionality: 'CAPTCHCR',
        rubric: 'F',
    },
    COMPTECR: {
        functionality: 'COMPTECR',
        rubric: 'F',
    },
    CONTRACR: {
        functionality: 'CONTRACR',
        rubric: 'F',
    },
};
